import { render, staticRenderFns } from "./SiteSharers.vue?vue&type=template&id=2379ba8a"
import script from "./SiteSharers.vue?vue&type=script&lang=js"
export * from "./SiteSharers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports